import { NOT_FOUND, request } from './request';

export interface TableDefaultData {
  state: unknown;
}

const path = (tableKey: string) => `/api/v2/table-defaults/${encodeURIComponent(tableKey)}/`;

/** `null` when the tenant has no default for the table. */
export async function get(tableKey: string): Promise<TableDefaultData | null> {
  try {
    return await request<TableDefaultData>(
      'GET',
      path(tableKey),
      {},
      { injectTenant: true, version: 2, silent404: true }
    );
  } catch (error: unknown) {
    if (error === NOT_FOUND) {
      return null;
    }

    throw error;
  }
}

export function save(tableKey: string, state: unknown): Promise<TableDefaultData> {
  return request('PUT', path(tableKey), { state }, { injectTenant: true, version: 2 });
}

export function remove(tableKey: string): Promise<void> {
  return request('DELETE', path(tableKey), {}, { injectTenant: true, version: 2 });
}
